// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5443) return "static/chunks/ad7f724d-365d834f95d30707.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"2442":"237fa57933380ef9","6350":"a4b650c88c962d42","7856":"3eeafc5151d77529","9679":"8c75641ed8acbec9"}[chunkId] + ".js";
};